var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { pre: true, attrs: { id: "ng", "ng-app": "app", class: "ng-content" } },
      [
        _c(
          "div",
          { attrs: { id: "appLoading", "ng-class": "{ hidden: !isLoading }" } },
          [
            _c("img", {
              attrs: {
                src: "/static/ng/images/logo-intelipost.png",
                alt: "Intelipost"
              }
            }),
            _vm._v(" "),
            _c("img", {
              attrs: {
                src: "/static/ng/images/loader.gif",
                alt: "Carregando..."
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            attrs: {
              id: "app",
              "ng-class": "{ show: !isLoading }",
              class: "wrapper hidden"
            }
          },
          [
            _c(
              "div",
              {
                attrs: {
                  id: "requestOverlay",
                  "ng-class": "{ active: showRequestOverlay }"
                }
              },
              [
                _c("i", {
                  attrs: { class: "fa fa-spinner zoomIn fa-spin fa-3x fa-fw" }
                })
              ]
            ),
            _vm._v(" "),
            _c("div", { attrs: { "data-ui-view": "" } })
          ]
        ),
        _vm._v(" "),
        _c("div", {
          attrs: {
            id: "Modal-container",
            "ui-view": "modal_container",
            autoscroll: "false"
          }
        })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c4e9494", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c4e9494","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-ng/Ng.vue
// module id = null
// module chunks = 